import { makeStyles } from '@material-ui/styles';
import { useMessageContext } from 'stream-chat-react';

import { Avatar, Timestamp } from '@bizzabo/collaboration-common';
import { Text } from '@bizzabo/design-system';
import { getPartnerName } from '../../../utils/helpers';

interface MessageContentHeaderProps {
    /**
     * Replaces the timestamp when the Stream Chat message fails
     */
    messageRetry?: React.ReactNode;
}

const MessageContentHeader: React.FC<MessageContentHeaderProps> = ({ messageRetry }) => {
    const { message, isMyMessage } = useMessageContext();
    const classes = useStyles();

    const displaySender = () => {
        return isMyMessage() ? 'You' : getPartnerName(message);
    };

    const messageFailed = message.status === 'failed';

    return (
        <div className={classes.topMessage}>
            <Avatar src={message.user.photoUrl as string} size={24} className={classes.avatar} />
            <Text className={classes.sender} variant="t71">
                {displaySender()}
            </Text>
            {messageFailed && messageRetry ? (
                messageRetry
            ) : (
                <Timestamp startTime={message.created_at} className={classes.timestamp} withDot />
            )}
        </div>
    );
};

const useStyles = makeStyles(
    theme => ({
        topMessage: {
            display: 'flex',
            alignItems: 'center',
        },
        avatar: {
            marginRight: 8,
        },
        sender: {
            color: theme.palette.greys[700],
            marginRight: 4,
        },
        timestamp: {
            marginTop: 3,
        },
    }),
    { classNamePrefix: 'chat-message-content-header' }
);

export default MessageContentHeader;
